import { CarInformation } from '../Types/FitAssistantData.ts';

export const getSearchString = (data: CarInformation[]): string =>
  data
    .filter((item: CarInformation) => ['make', 'model', 'year'].includes(item.parameterName.toLowerCase()))
    .map(
      (item: CarInformation) =>
        `${item.parameterName.toLowerCase()}:${encodeURIComponent(item.value)}|${encodeURIComponent(item.text)}`
    )
    .join(',');

export const getPerCategorySearchString = (data: CarInformation[]): string =>
  data
    .filter((item: CarInformation) => !['make', 'model', 'year'].includes(item.parameterName.toLowerCase()))
    .map(
      (item: CarInformation) =>
        `${item.parameterName.toLowerCase()}:${encodeURIComponent(item.value)}|${encodeURIComponent(item.text)}`
    )
    .join(',');
